"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthStorageKey = void 0;
const utils_1 = require("../utils");
var AuthStorageKey;
(function (AuthStorageKey) {
    AuthStorageKey["Profile"] = "profile";
    AuthStorageKey["SessionToken"] = "idToken";
})(AuthStorageKey = exports.AuthStorageKey || (exports.AuthStorageKey = {}));
const createAuthService = (client, storage) => {
    const getToken = (config) => client.getTokenSilently(config);
    const getIdToken = async () => {
        const claims = await client.getIdTokenClaims();
        // eslint-disable-next-line no-underscore-dangle
        return claims?.__raw;
    };
    return {
        getToken,
        getIdToken,
        getIdTokenClaims: () => client.getIdTokenClaims(),
        isAuthenticated: () => client.isAuthenticated(),
        login: (config) => client.loginWithRedirect(config),
        setProfile: (profile) => storage.setItem(AuthStorageKey.Profile, JSON.stringify(profile)),
        getProfile() {
            const profile = storage.getItem(AuthStorageKey.Profile);
            return profile ? JSON.parse(profile) : undefined;
        },
        async logout(options = {}) {
            await client.logout(options);
            storage.removeItem(AuthStorageKey.Profile);
            storage.removeItem(AuthStorageKey.SessionToken);
        },
        async handleRedirect() {
            const { appState } = await client.handleRedirectCallback();
            const user = await client.getUser();
            this.setProfile(user);
            return appState;
        },
        async getSessionToken() {
            let token = storage.getItem(AuthStorageKey.SessionToken);
            if (!(0, utils_1.jwtIsValid)(token)) {
                await getToken();
                token = (await getIdToken());
                storage.setItem(AuthStorageKey.SessionToken, token);
            }
            return token;
        },
    };
};
exports.default = createAuthService;
